<template>
  <v-card>
    <v-card-title>ご予約内容</v-card-title>

    <v-card-text>
      <h3 class="has-border">予約先</h3>
      <div>{{profile.name}}</div>

      <h3 class="has-border">ご利用日時</h3>
      <div class="d-flex">
        <confirm-time class="flex-grow-1" :time="bookPeriod.begin"/>
        <v-icon>arrow_right</v-icon>
        <confirm-time class="flex-grow-1" :time="bookPeriod.end"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import PartBase from '@/mixins/PartBase'
import ConfirmTime from './ConfirmTime'
import { mapGetters } from 'vuex'

export default {
  name: 'ConfirmSummary',
  mixins: [
    PartBase
  ],
  components: {
    ConfirmTime
  },
  computed: {
    ...mapGetters('shop', [
      'profile'
    ]),
    ...mapGetters('book', [
      'bookPeriod'
    ])
  }
}
</script>
